import React from "react";

const BreadCrumbContext = React.createContext("light");
export default BreadCrumbContext;